import { gql } from "@apollo/client";

export const GET_QUEUE_RECORD_QUERY = gql`
  query GetQueueRecord($id: ID!) {
    getQueueRecord(id: $id) {
      id
      name
      status
      createdAt
      updatedAt
      data
      messageId
      receiptHandle
      body
      attributes
    }
  }
`;
